import { render, staticRenderFns } from "./PanelHead.vue?vue&type=template&id=a67a80ae&scoped=true&"
import script from "./PanelHead.vue?vue&type=script&lang=js&"
export * from "./PanelHead.vue?vue&type=script&lang=js&"
import style0 from "./PanelHead.vue?vue&type=style&index=0&id=a67a80ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67a80ae",
  null
  
)

export default component.exports